function removeData() {
  return dispatch => {
    dispatch({ type: 'USER_AUTH', isAuth: false })
    dispatch({ type: 'TOKEN_INFO', tokens: {} })
    dispatch({ type: 'USERS_INFO', users: [] })
    dispatch({ type: 'EVENTS_INFO', events: [] })
    dispatch({ type: 'GROUPS_INFO', groups: [] })
    dispatch({ type: 'CONTROLLERS_INFO', controllers: [] })
  };
}

export default {
  removeData,
};
